(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-andrestella-dashboard"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    if(!document.querySelector('.and-club'))return;
    document.querySelectorAll('.and-rewards:not([data-ready])').forEach(panel=>{
      panel.dataset.ready='true';
      const root=panel.closest('.and-club');
      const demo=panel.dataset.demo==='true';
      const member=panel.dataset.member==='true';
      const cards=[...panel.querySelectorAll('.and-reward')];
      const balance=root.querySelector('.rivo-points-balance');
      const parse=value=>{const clean=String(value??'').replace(/[\s\u00a0\u202f,]/g,'');return /^\d+$/.test(clean)?Number(clean):null;};
      let points=parse(panel.dataset.points);
      function update(){
        if(balance){const value=parse(balance.textContent);if(value!==null)points=value;}
        cards.forEach(card=>{
          const cost=Number(card.dataset.cost);
          const unlocked=member&&points!==null&&points>=cost;
          const native=document.getElementById('rivo-reward-'+card.dataset.rewardId);
          const ready=Boolean(card.dataset.rewardId)&&(demo||Boolean(native&&!native.disabled&&native.getAttribute('aria-disabled')!=='true'));
          const button=card.querySelector('button');
          card.classList.toggle('is-locked',!unlocked);
          card.querySelector('.and-reward-state').textContent=unlocked?'Disponible':'À débloquer';
          card.querySelector('.and-reward-message').textContent=!member?'Connectez-vous pour voir votre progression':points===null?'Synchronisation de vos Étoiles…':unlocked?(ready?'':'Le service de récompenses est momentanément indisponible'):'Encore '+new Intl.NumberFormat('fr-FR').format(cost-points)+' ⭐️ Étoiles';
          button.disabled=member?(!unlocked||!ready):false;
          button.textContent=!member?'Me connecter':!unlocked?'À débloquer':!ready?'Indisponible':'Utiliser mes Étoiles';
          button.setAttribute('aria-label',button.textContent+' — '+card.querySelector('h3').textContent);
        });
      }
      update();
      if(balance)new MutationObserver(update).observe(balance,{childList:true,characterData:true,subtree:true});
      const serviceRoot=document.getElementById('MainContent');
      if(serviceRoot&&!demo&&member){
        let exchangePending=false;
        let exchangeConfirmed=false;
        document.addEventListener('click',event=>{
          const confirmation=event.target.closest('#way-to-redeem-modal [aria-label="Redeem this reward"]');
          if(confirmation&&!document.querySelector('#way-to-redeem-modal .rivo-coupon-code'))exchangePending=true;
        },true);
        new MutationObserver(()=>{
          const modal=document.getElementById('way-to-redeem-modal');
          if(!modal||!exchangePending)return;
          if(!exchangeConfirmed&&modal.querySelector('.rivo-coupon-code')&&modal.querySelector('[data-points-purchase-id]')){
            exchangeConfirmed=true;
            points=null;
            if(balance)balance.textContent='…';
            panel.querySelector('.and-rewards-feedback').textContent='Votre échange est confirmé. Votre solde sera actualisé à la fermeture du bon.';
            update();
          }
          if(exchangeConfirmed&&modal.getAttribute('aria-hidden')==='true'){
            exchangePending=false;
            location.reload();
          }
        }).observe(serviceRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-hidden']});
      }
      if(serviceRoot&&!demo)new MutationObserver(records=>{if(records.some(record=>!panel.contains(record.target)))update();}).observe(serviceRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      panel.addEventListener('click',event=>{
        const button=event.target.closest('.and-reward-button');
        if(!button||button.disabled)return;
        if(!member){const login=root.querySelector('.and-club-member .and-club-cta');if(login)location.href=login.href;return;}
        if(demo){panel.querySelector('.and-rewards-feedback').textContent='Récompense sélectionnée : '+button.closest('.and-reward').querySelector('h3').textContent+'.';return;}
        update();
        if(button.disabled)return;
        const native=document.getElementById('rivo-reward-'+button.closest('.and-reward').dataset.rewardId);
        if(native){native.click();}else{panel.querySelector('.and-rewards-feedback').textContent='Le service de récompenses se charge. Réessayez dans un instant.';}
      });
      document.documentElement.classList.add('and-rewards-enhanced');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(function(){
 function setupWelcome(){
  const root=document.querySelector('#MainContent');
  if(!root||root.dataset.clubWelcomeReady)return;
  root.dataset.clubWelcomeReady='true';
  function sync(){
   const card=root.querySelector('#rivo-earning-rule-632959');
   const demo=root.querySelector('.and-rewards[data-demo="true"]');
   if(!card||(!demo&&!card.classList.contains('completed')))return;
   const title=card.querySelector('.rivo-card-title'),desc=card.querySelector('.rivo-card-description');
   if(title&&title.textContent!=='Bienvenue au Club')title.textContent='Bienvenue au Club';
   if(desc&&desc.textContent!=='Votre bonus de bienvenue a été reçu')desc.textContent='Votre bonus de bienvenue a été reçu';
   if(!card.disabled)card.disabled=true;
  }
  sync();
  new MutationObserver(sync).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupWelcome);else setupWelcome();
 document.addEventListener('shopify:section:load',setupWelcome);
})();

document.addEventListener('click',function(event){
const link=event.target.closest('.and-club-level[href^="#and-detail-"]');
if(!link)return;
const target=document.querySelector(link.getAttribute('href'));
if(target)target.open=true;
});

(function(){
 function arrangeClub(){
  const root=document.querySelector('.and-club');
  const guide=root&&root.querySelector('.and-participations');
  const earn=document.querySelector('#rivo-ways-to-earn');
  if(!root||!guide||!earn)return;
  const block=earn.closest('.shopify-app-block');
  if(block&&block.parentElement!==root)root.insertBefore(block,guide);
 }
 function start(){
  arrangeClub();
  const main=document.querySelector('#MainContent');
  if(main&&!main.dataset.clubOrderObserved){
   main.dataset.clubOrderObserved='true';
   new MutationObserver(arrangeClub).observe(main,{childList:true,subtree:true});
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('andrestella-footer-menu')) {
  customElements.define('andrestella-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.media = window.matchMedia('(min-width: 750px)');
      this.sync = () => {
        this.details.open = this.media.matches;
        if (this.media.matches) this.summary.setAttribute('tabindex', '-1');
        else this.summary.removeAttribute('tabindex');
      };
      this.handleClick = event => { if (this.media.matches) event.preventDefault(); };
      this.summary.addEventListener('click', this.handleClick);
      this.media.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.summary.removeEventListener('click', this.handleClick);
      this.media.removeEventListener('change', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
